import React from "react";
import "./styles.scss";
import "./mobile.scss";
import { GetIconByName } from "../../config/icon";
import { FooterHeader } from "../../components";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";

const Index = (props) => {
  return (
    <>
      <div className={"footer-main-wrapper"}>
        <div className={"container"}>
          <div className={`footer-wrapper`}>
            <div className={"fw__top"}>
              <div className={"fwt__details"}>
                <div className={"fwtd__logo"}>
                  <img src={require("../../assets/img/lgo.png")} alt={"logo"} />
                </div>
                <div className={"fwtd__content"}>
                  {"Trusted source for breaking news, politics, and global affairs—delivering timely," +
                    " accurate, and unbiased updates that matte."}
                </div>
                <div className={"fwtd__location"}>
                  <div style={{ fontSize: "16px" }}>
                    {GetIconByName("home")}
                  </div>
                  <span style={{ marginLeft: "12px" }}>
                    {"Sri Lanka, Colombo"}
                  </span>
                </div>
                <div className={"fwtd__mail"}>
                  <div style={{ fontSize: "16px" }}>
                    {GetIconByName("mail")}
                  </div>
                  <span style={{ marginLeft: "12px" }}>
                    {"contact@hopeofanewera.org"}
                  </span>
                </div>
              </div>
              {/*<div className={"fwt__links"}>*/}
              {/*  <div className={"fwtl__title"}>{"Links"}</div>*/}
              {/*  <div className={"fwtl__link"}>{"Publisher"}</div>*/}
              {/*  <div*/}
              {/*    className={"fwtl__link"}*/}
              {/*    onClick={() => {*/}
              {/*      props.history.push("/ads");*/}
              {/*    }}*/}
              {/*  >*/}
              {/*    {"Advertisement"}*/}
              {/*  </div>*/}
              {/*  <div className={"fwtl__link"}>{"Sign in"}</div>*/}
              {/*</div>*/}
              <div className={"fwt__quick-links"}>
                <div className={"fwtql__title"}>{"Quick links"}</div>
                <div
                  className={"fwtql__link"}
                  onClick={() => {
                    props.history.push("/return-policy");
                  }}
                >
                  {"Refund policy"}
                </div>
                <div
                  className={"fwtql__link"}
                  onClick={() => {
                    props.history.push("/privacy-policy");
                  }}
                >
                  {"Privacy policy"}
                </div>
                <div
                  className={"fwtql__link"}
                  onClick={() => {
                    props.history.push("/terms-conditions");
                  }}
                >
                  {"Terms & Conditions"}
                </div>
              </div>
              <div className={"fwt__following"}>
                <div className={"fwtf__title"}>{"Following us"}</div>
                <div className={"fwtf__social"}>
                  <div className={"fwtfs__logo"}>
                    <a
                      href="https://www.facebook.com/profile.php?id=61563414671127"
                      target="_blank"
                      className="fwtfs__l-icon"
                    >
                      {GetIconByName("facebook")}
                    </a>
                  </div>
                  {/*<div className={"fwtfs__logo"}>*/}
                  {/*  <a*/}
                  {/*    href="https://www.tiktok.com/@creditcardoffers.lk?is_from_webapp=1&sender_device=pc"*/}
                  {/*    target="_blank"*/}
                  {/*    className="fwtfs__l-icon"*/}
                  {/*  >*/}
                  {/*    {GetIconByName("whatsapp")}*/}
                  {/*  </a>*/}
                  {/*</div>*/}
                  <div className={"fwtfs__logo"}>
                    <a
                      href="https://www.instagram.com/creditcardoffers.lk/"
                      target="_blank"
                      className="fwtfs__l-icon"
                    >
                      {GetIconByName("instagram")}
                    </a>
                  </div>
                  <div className={"fwtfs__logo"}>
                    <a
                        href="https://x.com/hopeofanewera/"
                        target="_blank"
                        className="fwtfs__l-icon"
                    >
                      {GetIconByName("twitter")}
                    </a>
                  </div>
                  <div className={"fwtfs__logo"}>
                    <a
                      href="https://www.youtube.com/@neweraofhope-n8r"
                      target="_blank"
                      className="fwtfs__l-icon"
                    >
                      {GetIconByName("youtube")}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterHeader />
    </>
  );
};
//export default Index;

export default withRouter(Index);
